const STATS = [
  { k: "950K+", v: "Active drivers worldwide" },
  { k: "12M+", v: "Masked calls relayed" },
  { k: "4×", v: "Revenue growth in 18 months" },
  { k: "98.7%", v: "Customer satisfaction score" },
];

export default function Stats() {
  return (
    <section data-testid="stats-section" className="bg-[#0F172A] text-white">
      <div className="container-secqre py-20 md:py-24">
        <div className="grid md:grid-cols-2 gap-12 items-start">
          <div>
            <span className="overline !text-white/60">— By the numbers</span>
            <h2 className="mt-4 font-heading font-bold text-4xl sm:text-5xl tracking-tight">
              The privacy layer for parked cars — already at scale.
            </h2>
            <p className="mt-5 text-white/70 max-w-lg text-lg">
              We invented this category in Asia and grew it past a million tags before crossing the
              Pacific. Now we&apos;re bringing the same engineering to the United States.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-px bg-white/10 rounded-2xl overflow-hidden">
            {STATS.map((s, i) => (
              <div key={i} className="bg-[#0F172A] p-7 md:p-9" data-testid={`stat-${i}`}>
                <div className="font-heading font-black text-5xl md:text-6xl tracking-tight text-[#FFD600]">{s.k}</div>
                <div className="mt-2 text-white/70 text-sm">{s.v}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
